"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _compound_components = require("./form_submit_buttons/compound_components");
var _excluded = ["children", "compact", "onSubmit", "submitText"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FormSubmitButtons = function FormSubmitButtons(props) {
  function cancel(event) {
    event.preventDefault();
    if (props.onCancel) {
      props.onCancel();
    }
  }
  function renderCancel() {
    var cancelLinkProps = props.cancelLinkProps,
      cancelText = props.cancelText,
      cancelComponent = props.cancelComponent,
      hideCancelButton = props.hideCancelButton;
    if (cancelComponent) {
      return /*#__PURE__*/React.cloneElement(cancelComponent, {
        onClick: cancel
      });
    } else if (!hideCancelButton) {
      return /*#__PURE__*/React.createElement(_compound_components.FormSubmitButtons.Cancel, (0, _extends2["default"])({
        onCancel: props.onCancel
      }, cancelLinkProps), cancelText);
    } else {
      return null;
    }
  }
  var children = props.children,
    compact = props.compact,
    onSubmit = props.onSubmit,
    submitText = props.submitText,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement(_compound_components.FormSubmitButtons.Row, {
    compact: compact,
    extraAction: children
  }, renderCancel(), /*#__PURE__*/React.createElement(_compound_components.FormSubmitButtons.Submit, (0, _extends2["default"])({
    onClick: onSubmit
  }, otherProps), submitText));
};
FormSubmitButtons.defaultProps = {
  cancelLinkProps: {},
  cancelText: 'Cancel',
  compact: false,
  fancy: false,
  hideCancelButton: false,
  isSubmitting: false,
  size: 'default',
  submitText: 'Save',
  disabled: false
};
var _default = exports["default"] = FormSubmitButtons;